let swiperInstances = [];

const swipperSlider = () => {
  // Destroy existing Swiper instances
  swiperInstances.forEach(swiper => swiper.destroy(true, true));
  swiperInstances = [];

  const sections = document.querySelectorAll('.swiper');

  sections.forEach((section) => {
    const desktopSlider = section.classList.contains('desktop_slider');
    const mobileSlider = section.classList.contains('mobile_slider');
    let isStatus = true;
    let centerSlide = false;
    let centeredSlidesBounds = false;
    let spaceBetween = ((mobileSlider || desktopSlider) && window.innerWidth > 768) ? 20 : 4;

    if (mobileSlider && window.innerWidth <= 768) {
      spaceBetween = section.dataset.spaceBetweenMobile || spaceBetween;
    }

    if (!desktopSlider && section.classList.contains('image-grid-container') && window.innerWidth >= 769) {
      section.classList.remove('swiper');
      isStatus = false;
    }

    if (!mobileSlider && section.classList.contains('image-grid-container') && window.innerWidth <= 768) {
      section.classList.remove('swiper');
      isStatus = false;
    }
    if(window.innerWidth < 769){
      centerSlide = true;
      centeredSlidesBounds = true;
    }
    console.log("space", spaceBetween);

    if (isStatus) {
      const swiper = new Swiper(section, {
        direction: 'horizontal',
        slidesPerView: 1.6,
        spaceBetween: parseInt(spaceBetween),
        loop: false,
        centeredSlides: false,
        centeredSlidesBounds: false,
        autoplay: section.dataset.autoplay === 'true' ? {
          delay: parseInt(section.dataset.autoplaySpeed) || 5000,
          disableOnInteraction: false,
        } : false,
        breakpoints: {
          768: {
            slidesPerView: parseInt(section.dataset.productsPerRowTab) || 1,
            spaceBetween: parseInt(spaceBetween),
          },
          1140: {
            slidesPerView: parseInt(section.dataset.productsPerRow) || 1,
            spaceBetween: parseInt(spaceBetween),
          },
        },
        scrollbar: {
          el: '.carousel-scrollbar',
          draggable: true,
          hide: false,
        },
        navigation: {
          nextEl: '.pager-next',
          prevEl: '.pager-prev',
        },
        on: {
          afterInit: function (swiper) {
            const interval = setInterval(() => {
              const scrollbarDrag = section.querySelector('.swiper-scrollbar-drag');
              if (scrollbarDrag) {
                const dragWidth = scrollbarDrag.offsetWidth;
                if (dragWidth === 0) {
                  swiper.update();
                } else {
                  clearInterval(interval);
                }
              }
            }, 100);
          }
        }
      });
      if(centerSlide){
        section.querySelector(".swiper-wrapper").style.transform = "translate3d(0px, 0px, 0px)";
      }
      setTimeout(function() {
          let swiperWrapper = section.querySelector('.swiper-wrapper');
          if (swiperWrapper.style.gap !== '0px' && swiperWrapper.style.gap !== '0') {
            swiperWrapper.style.gap = '0';
            swiperWrapper.style.overflow = 'visible';
            section.querySelectorAll('.swiper-slide').forEach((item, index) => {
              item.style.flex = 'none';
            });
          }
        }, 1000);
      swiperInstances.push(swiper);
    }
  });

  document.querySelectorAll(".carousel__pager").forEach((item) => {
    item.style.display = "flex";
  });
};

// Re-initialize on resize with debounce
let resizeTimeout;
let previousWidth = window.innerWidth;

window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    const currentWidth = window.innerWidth;
    if (currentWidth !== previousWidth) {
      previousWidth = currentWidth;
      swipperSlider();
    }
  }, 300);
});



document.querySelectorAll(".carousel__pager").forEach((item, index) => {
  item.style.display = "flex"; // Corrected: Removed the extra semicolon inside the string
});

// Call the function initially
swipperSlider();
// Reinitialize on Shopify section load
document.addEventListener('shopify:section:load', () => {
  swipperSlider();
});
